import { SCOPE } from '@store/noc/index';
import { get } from 'lodash';

const selector = state => get(state, SCOPE);
export default selector;
